// String values are tied to backend
export enum PortfolioRegion {
    UNITED_STATES = 'UNITED_STATES',
    CANADA = 'CANADA',
    UNITED_KINGDOM = 'UNITED_KINGDOM',
    FRANCE = 'FRANCE'
}
